import { lazy } from 'react';
import commonPath from 'src/constants/urlPath/erp/commonPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';
import urlPath from 'src/constants/urlPath/urlPath';

const DashboardPage = lazy(() => import('src/pages/ERP/Dashboard'));

const commonRoute: RouteType[] = [
  {
    path: commonPath.erp,
    Layout: NewLayout,
    Component: DashboardPage
  },
  {
    path: urlPath.home.location,
    redirect: commonPath.erp
  }
];

export default commonRoute;
